// Map from coordinates or a saved address. Uses Google Maps embed (no Google API files changed).
import React from "react";

const IpLocationMap = ({
  latitude,
  longitude,
  query,
  label,
  height = "180px",
  zoom = 15,
}) => {
  const lat = latitude != null ? Number(latitude) : null;
  const lng = longitude != null ? Number(longitude) : null;
  let q = "";
  if (Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0)) {
    q = `${lat},${lng}`;
  } else if (query) {
    q = String(query).trim();
  }
  if (!q) return null;

  const src = `https://maps.google.com/maps?q=${encodeURIComponent(q)}&z=${zoom}&hl=en&output=embed`;

  return (
    <iframe
      title={label || "Current location"}
      src={src}
      className="rounded-lg border border-[#E9EDF9] w-full"
      style={{ height, border: 0 }}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      allowFullScreen
    />
  );
};

export default IpLocationMap;
